export const Navigation = (props) => {
  return (
    <nav id='menu' className='navbar navbar-default navbar-fixed-top'>
      <div className='container'>
        <div className='navbar-header'>
          <button
            type='button'
            className='navbar-toggle collapsed'
            data-toggle='collapse'
            data-target='#bs-example-navbar-collapse-1'
          >
            {' '}
            <span className='sr-only'>Toggle navigation</span>{' '}
            <span className='icon-bar'/>{' '}
            <span className='icon-bar'/>{' '}
            <span className='icon-bar'/>{' '}
          </button>
          <a className='navbar-brand page-scroll' href='#page-top' style={{marginTop: '1.5rem'}}>
            Strzelnica <br/>Twierdza Kłodzko
          </a>{' '}
        </div>

        <div
          className='collapse navbar-collapse'
          id='bs-example-navbar-collapse-1'
        >
          <ul className='nav navbar-nav navbar-right' >
            {/*<li>*/}
            {/*  <a href='#features' className='page-scroll'>*/}
            {/*    Features*/}
            {/*  </a>*/}
            {/*</li>*/}
            <li>
              <a href='#about' className='page-scroll'>
                O nas
              </a>
            </li>
            <li>
              <a href='/?product=pakiet-0' className='page-scroll'>
                Dostępna broń
              </a>
            </li>
            <li>
              <a href='https://strzelnicahistoryczna.pl' target="_blank" className='page-scroll'>
                Twierdza Srebrna Góra
              </a>
            </li>
            {/*<li>*/}
            {/*  <a href='#testimonials' className='page-scroll'>*/}
            {/*    Testimonials*/}
            {/*  </a>*/}
            {/*</li>*/}
            {/*<li>*/}
            {/*  <a href='#team' className='page-scroll'>*/}
            {/*    Team*/}
            {/*  </a>*/}
            {/*</li>*/}
            <li>
              <a href='#contact' className='page-scroll'>
                Kontakt
              </a>
            </li>
            <li>
              <a  href={"/"} className={"bookitone-booking-init"} data-id="410d5405-c8d8-4e9c-bef7-366adade74d8" data-color="515928" style={{color: "#515928"}}><div style={{background: '#515928', padding: '1rem', color: "#fff", marginBottom: '1rem'}}>Zarezerwuj pakiet</div></a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  )
}
